import React from "react";

import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

function Header4() {
  return (
    <header className="header-4">
      <div className="page-header">
        <Container className="text-center">
          <Row>
            <Col className="mx-auto" lg="10">
              <h1 hidden>Cryptegridy</h1>
              <img className="img-fluid" src={require("assets/img/longblue.png")} alt="..." />
              <h2 className="h4 font-weight-normal text-default">
                At the heart of our operations, we specialize in leveraging human intelligence 
                to protect you from malicious activities. Whether you are an individual or a 
                business, we are committed to delivering the highest level of protection.
              </h2>
              <Button
                className="mt-3 mb-sm-0"
                color="info"
                href="#prefooter"
              >
                <span className="btn-inner--text text-default">Contact Us</span>
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </header>
  );
}

export default Header4;
